/**
 * @generated SignedSource<<6b63e831b956ec0f2187ea294197b4eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchFederatedResult_AtlassianSearchPage$data = {
  readonly description: string;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchFederatedEmail_AtlassianSearchPage">;
  readonly " $fragmentType": "searchFederatedResult_AtlassianSearchPage";
};
export type searchFederatedResult_AtlassianSearchPage$key = {
  readonly " $data"?: searchFederatedResult_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchFederatedResult_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchFederatedResult_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchFederatedEmail_AtlassianSearchPage"
    }
  ],
  "type": "SearchResultFederated"
};

(node as any).hash = "54b396c04e9434e8bfcf5a97cc47d5fa";

export default node;
